import { ShiftAuthRequestError } from './shift-request-error';
import type { ApiErrorPayload } from './shift-request-error';

const backendBaseUrl = process.env.REACT_APP_BACKEND_LOCATION ?? '/__shift_api__';

const resolveUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${backendBaseUrl}${normalizedPath}`;
};

const readJsonSafe = async (response: Response): Promise<ApiErrorPayload | null> => {
  const contentType = response.headers.get('content-type')?.toLowerCase() ?? '';
  if (!contentType.includes('application/json')) {
    return null;
  }

  try {
    return (await response.json()) as ApiErrorPayload;
  } catch {
    return null;
  }
};

export const createShiftJsonClient = (networkErrorMessage: string, includeJsonHeader = true) => {
  return async <T>(path: string, init?: RequestInit): Promise<T> => {
    let response: Response;

    try {
      response = await fetch(resolveUrl(path), {
        ...init,
        credentials: 'include',
        ...(includeJsonHeader
          ? { headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) } }
          : {}),
      });
    } catch {
      throw new ShiftAuthRequestError(networkErrorMessage, 0, true, null);
    }

    const payload = await readJsonSafe(response);
    if (!response.ok) {
      const payloadMessage = payload?.message;
      const message = Array.isArray(payloadMessage)
        ? payloadMessage.join(', ')
        : typeof payloadMessage === 'string'
          ? payloadMessage
          : `HTTP ${response.status}`;

      throw new ShiftAuthRequestError(message, response.status, false, payload);
    }

    return payload as T;
  };
};
